import { useState, useEffect } from "react"
import "./Modal.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCheckSquare } from "@fortawesome/free-solid-svg-icons"

const Modal = ({ show, closeModal, expediente }) => {
	const [data, set_data] = useState("")
	const [showModal, setShowModal] = useState(!data)

	useEffect(() => {
		async function fetchData() {
			try {
				const response = await fetch(`/api/query/detail?id=${expediente}`)
				const data = await response.json()
				if (data !== null) {
					set_data(data)
				}
			} catch (error) {
				console.log(error)
			}
		}
		fetchData()
	}, [expediente])

	const ConvertCoordinates = ({ coordinates }) => {
		const convert = (coord) => {
			const lat_length = coord.length / 2
			const lat = coord.slice(0, lat_length)
			const long = "-" + coord.slice(lat_length, lat_length * 2)
			return lat.slice(0, 2) + "." + lat.slice(2) + "," + long.slice(0, 3) + "." + long.slice(3)
		}

		return <>{convert(coordinates)}</>
	}

	return (
		<div className="record">
			<h1>CONSULTA DE CERTIFICACIÓN</h1>
			<div className="Chr" />
			{!data ? (
				<>
					{showModal && (
						<div className="modal">
							<div className="modal-content">
								<h2>Expediente no encontrado</h2>
								<p>Lo sentimos, el expediente que estás buscando no fue encontrado.</p>
							</div>
						</div>
					)}
				</>
			) : (
				<>
					<div className="message">
						<div className="icon">
							<FontAwesomeIcon icon={faCheckSquare} />
						</div>
						<p className="messageP">
						Este proyecto está aprobado por la Oficina de Planeamiento Urbano del Ayuntamiento de La Vega.
						</p>
					</div>
					<table className="tablet">
						<tr>
							<td>
								<b>EXPEDIENTE Nº:</b>
							</td>
							<td className="data">{data?.expediente}</td>
						</tr>
						<div className="hr" />
						<tr>
							<td>
								<b>Nombre Proyecto:</b>
							</td>
							<td className="data">{data?.nombre}</td>
						</tr>
						<div className="hr" />
						<tr>
							<td>
								<b>Datos del Solicitante:</b>
							</td>
							<td className="data">{data?.nombre_solicitante}</td>
						</tr>
						<div className="hr" />
						<tr>
							<td>
							<b>Dirección:</b>
							</td>
							<td className="data">{data?.direccion}</td>
						</tr>
						<div className="hr" />
						<tr>
							<td>
								<b>Coordenadas UTM:</b>
							</td>
							<td className="data">
								{data?.coordenadas && <ConvertCoordinates coordinates={data.coordenadas} />}
							</td>
						</tr>
						<div className=" hr" />
					</table>
				</>
			)}
			<button onClick={closeModal}>Cerrar</button>
		</div>
	)
}

export default Modal
